// Send back whatever is sent in.
const getLabel = function(options) {
  let key = ''
  if (typeof(options) === 'string') {
    key = options
  } else {
    key = options.key
  }
  return key
}

export default getLabel
